import {
	sBanner,
	sShowScreen,
	sInputKeyValidationHelper,
	sAppendSafeLink,
	sGetFromEngagementTools,
} from '../../shared.min.js';

const airlineDelay = (function () {
	const widget = document.getElementById('cnfsd-airline-delay-compensation'),
		screens = widget.querySelectorAll('.widget__screen'),
		dataUrl = widget ? widget.getAttribute('data-json') : widget.getAttribute('data-json-path'),
		progressTitle1 = widget ? widget.getAttribute('data-progress-title-1') || '' : null,
		progressTitle2 = widget ? widget.getAttribute('data-progress-title-2') || '' : null,
		fieldGroup = widget ? widget.querySelectorAll('.field-group') : null,
		submitButton = widget ? widget.querySelector('#submit') : null,
		restartButton = widget ? widget.querySelector('#restart') : null,
		flightNumberInput = widget ? widget.querySelector('#flight_number') : null,
		flightNumberInputFieldGroup = flightNumberInput ? flightNumberInput.closest('.field-group') : null,
		flightNumberRegex = /^([A-Za-z0-9]{2})[0-9]{1,4}([A-Za-z])?$/,
		flightDepartureAirport = widget ? widget.querySelector('#flight_departure_airport') : null,
		flightDepartureAirportFieldGroup = flightDepartureAirport
			? flightDepartureAirport.closest('.field-group')
			: null,
		flightDepartureDate = widget ? widget.querySelector('#flight_departure_date') : null,
		flightDepartureTime = widget ? widget.querySelector('#flight_departure_time') : null,
		flightDepartureDateFieldGroup = flightDepartureDate ? flightDepartureDate.closest('.field-group') : null,
		resultSections = widget.querySelectorAll('.widget__results'),
		resultsSuccessScreen = widget ? widget.querySelector('.widget__results--success') : null,
		apiCallFailedScreen = widget ? widget.querySelector('.widget__results--api-call-failed') : null,
		flightNotFoundScreen = widget ? widget.querySelector('.widget__results--flight-not-found') : null,
		notCoveredRegsScreen = widget ? widget.querySelector('.widget__results--not-covered-regs') : null,
		compensationDistance = widget ? widget.querySelector('.compensation__workings--distance') : null,
		compensationDelay = widget ? widget.querySelector('.compensation__workings--delay') : null,
		compensationDelaySub3hrs = widget ? widget.querySelector('.compensation__delay-sub-3hrs') : null,
		compensationRegulationLink = widget ? widget.querySelector('.compensation__regulation-link') : null,
		compensationValue = widget ? widget.querySelector('.compensation__value') : null,
		airlinePolicyLink = widget ? widget.querySelector('.next-steps__airline-policy-link') : null,
		nextStepsList = widget ? widget.querySelectorAll('.next-steps__list') : null;

	let errorType = 0,
		formattedDateTime = '',
		euAirlines = [],
		euAirports = [],
		departureAirportData = null,
		flightApiUrl = '',
		airportApiUrl = '',
		airportLookupUrl = '',
		apiKey = '';

	const init = () => {
		sBanner(
			widget,
			[progressTitle1, progressTitle2],
			'.banner-current-text',
			'.banner-current-progress',
			'.banner__progress-bar__bar',
			1
		);

		sInputKeyValidationHelper(flightNumberInput, 'alphaNumeric', flightNumberInputFieldGroup);
		sInputKeyValidationHelper(flightDepartureAirport, 'alphaNumeric', flightDepartureAirportFieldGroup);
		sInputKeyValidationHelper(flightDepartureDate, 'numeric', flightDepartureDateFieldGroup);
		sInputKeyValidationHelper(flightDepartureTime, 'numeric', flightDepartureDateFieldGroup);

		getApiDetails();
	};

	// HELPER METHOD:: Retrieves the API URL based upon the hostname of where the app is running
	function getApiDetails() {
		flightApiUrl = widget
			? widget.getAttribute('data-api-flight-url')
			: 'http://localhost:3000/flight-aware/flight';
		airportApiUrl = widget
			? widget.getAttribute('data-api-airport-url')
			: 'http://localhost:3000/flight-aware/airports';
		airportLookupUrl = widget
			? widget.getAttribute('data-airportlookup-url')
			: 'https://www.local-confused.com/api/airportlookup';
		apiKey = widget ? widget.getAttribute('data-api-key') : '';
		if (flightApiUrl.includes('local-')) {
			flightApiUrl = 'http://localhost:3000/flight-aware/flight';
			airportApiUrl = 'http://localhost:3000/flight-aware/airports';
			airportLookupUrl = 'https://www.local-confused.com/api/airportlookup';
			apiKey = '';
		}
	}

	// event listeners

	submitButton.addEventListener('click', async e => {
		formattedDateTime = '';
		fieldGroup.forEach(group => group.classList.remove('field-group--error'));
		e.preventDefault();
		errorType = 0; // Reset error type
		let isValid = true;

		if (flightNumberInput.value.trim() === '') {
			// nearest fieldgroup to flight number input
			flightNumberInput.closest('.field-group').classList.add('field-group--error');
			isValid = false;
		}

		// Validate flight number against regex
		const flightNumber = flightNumberInput.value.trim().toUpperCase();
		if (!new RegExp(flightNumberRegex).test(flightNumber)) {
			flightNumberInput.closest('.field-group').classList.add('field-group--error');
			isValid = false;
		}

		const flightDepartureAirportCode = flightDepartureAirport.value.trim().toUpperCase();
		if (flightDepartureAirportCode === '') {
			flightDepartureAirport.closest('.field-group').classList.add('field-group--error');
			isValid = false;
		}

		if (flightDepartureDate.value === '') {
			flightDepartureDate.closest('.field-group').classList.add('field-group--error');
			isValid = false;
		}

		if (flightDepartureTime.value === '') {
			flightDepartureTime.closest('.field-group').classList.add('field-group--error');
			isValid = false;
		}

		if (flightDepartureDate.value && flightDepartureTime.value) {
			const dateTime = new Date(`${flightDepartureDate.value}T${flightDepartureTime.value}`);
			if (isNaN(dateTime.getTime())) {
				flightDepartureDate.closest('.field-group').classList.add('field-group--error');
				isValid = false;
			}
			if (dateTime > new Date()) {
				flightDepartureDate.closest('.field-group').classList.add('field-group--error');
				isValid = false;
			}

			// Check if date is within last 6 years
			const sixYearsAgo = new Date();
			sixYearsAgo.setFullYear(sixYearsAgo.getFullYear() - 6);
			if (dateTime < sixYearsAgo) {	
				flightDepartureDate.closest('.field-group').classList.add('field-group--error');
				isValid = false;
			}
		}

		if (!isValid) {
			return;
		}

		try {
			// Validate flight number input

			// async await function to fetch flight data
			if (flightDepartureDate && flightDepartureTime) {
				formattedDateTime = await getFormattedDateTime(
					flightDepartureAirportCode,
					flightDepartureDate.value,
					flightDepartureTime.value
				);
				if (!formattedDateTime || !formattedDateTime.start) {
					flightDepartureTime.closest('.field-group').classList.add('field-group--error');
					return;
				}
			}

			const flight = await getFlightData(flightNumber, formattedDateTime.start, formattedDateTime.end);

			// check if flight is found
			if (!flight) {
				errorType = 1; // Flight not found
				throw new Error('API Error'); 
			}
			
			// check if flight is found
			if (!flight.flights || flight.flights.length === 0) {
				errorType = 2; // Flight not found
				throw new Error('Flight not found'); 
			}
			
			if (flight) {
				const isCovered = await isEUFlight(flight);
				if (!isCovered) {
					errorType = 3; // Not covered by EU regulations
				}
			}
			showResultsScreen(flight);
		} catch (err) {
			// The errorType will be set in getFlightData or isEUFlight
			showResultsScreen(null);

		} finally {
			sShowScreen(screens, 2);
		}
	});

	restartButton.addEventListener('click', e => {
		e.preventDefault();
		fieldGroup.forEach(group => group.classList.remove('field-group--error'));
		flightNumberInput.value = '';
		flightDepartureAirport.value = '';
		flightDepartureDate.value = '';
		flightDepartureTime.value = '';
		// Reset all values to default
		compensationDistance.textContent = '';
		compensationDelay.textContent = '';
		compensationDelaySub3hrs.classList.add('display-none');
		compensationValue.classList.add('display-none');
		compensationRegulationLink.classList.add('display-none');
		// Hide all result sections
		resultSections.forEach(section => {
			section.classList.add('display-none');
		});
		// reset all variables
		errorType = 0;
		formattedDateTime = '';
		departureAirportData = null;

		sShowScreen(screens, 1);
		scrollToBanner();
	});

	const getFormattedDateTime = async (flightDepartureAirportCode, dateValue, timeValue) => {
		let departureAirport = null;

		if (!flightDepartureAirportCode || flightDepartureAirportCode === '') {
			console.warn('Flight departure airport code is missing.');
			return;
		}

		if (!dateValue || !timeValue) {
			console.warn('Date or time input is missing.');
			return;
		}

		departureAirport = await getAirportData(flightDepartureAirportCode, `${dateValue}T${timeValue}`, true);

		if (!departureAirport || !departureAirport.utcDateTime) {
			console.warn('Unable to fetch departure airport data.');
			return;
		}

		// Parse as UTC by adding 'Z' (ISO 8601 UTC designator)
		const startUTC = new Date(departureAirport.utcDateTime);

		// End time = start + 59 seconds
		const endUTC = new Date(startUTC.getTime() + 59000);

		const urlEncodedStart = encodeURIComponent(`${startUTC.toISOString().split('.')[0]}Z`);
		const urlEncodedEnd = encodeURIComponent(`${endUTC.toISOString().split('.')[0]}Z`);

		return {
			start: urlEncodedStart,
			end: urlEncodedEnd,
		};
	};

	const getFlightData = async (flightNumber, start, end) => {
		let flightData = null;
		errorType = '';
		const requestUrl = `${flightApiUrl}?flightNumber=${flightNumber}&start=${start}&end=${end}`;

		try {
			const res = await sGetFromEngagementTools(apiKey, requestUrl);

			if (!res.ok) {
				errorType = 1;
				throw new Error('Network response was not ok');
			}

			if (res.status === 400 || res.status === 404) {
				errorType = 2;
				throw new Error('Flight not found');
			}

			flightData = await res.json();
			errorType = 0;
			return flightData;
		} catch (error) {

			console.error('Error fetching flight data:', error);
		}
	};

	const getAirportData = async (airportCode, localDateTime = '', departure = false) => {
		if (!airportCode || airportCode === '') {
			console.warn('Airport code is missing.');
			return null;
		}

		// If we are fetching departure data, or if a cached departure airport matches the request, use it.
		if (departure && departureAirportData && departureAirportData.iata_code === airportCode) {
			return departureAirportData;
		}

		const requestUrl = localDateTime
			? `${airportLookupUrl}/${airportCode}?historicalDate=${localDateTime}`
			: `${airportLookupUrl}/${airportCode}`;

		try {
			const res = await fetch(requestUrl);
			if (!res.ok) {
				throw new Error('Network response was not ok');
			}
			const airportData = await res.json();
			if (departure) {
				departureAirportData = airportData; // Cache the departure airport data
			}
			return airportData; // Return the fetched data
		} catch (error) {
			errorType = 1; // Set error type for API call failure
			showResultsScreen(null);
			console.error('Error fetching airport data:', error);
			return null;
		}
	};

	const fetchEUAirlines = async () => {
		try {
			const response = await fetch(dataUrl);
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			const data = await response.json();
			euAirlines = data.airlines || [];
			euAirports = data.airports || [];

			return data;
		} catch (error) {
			console.error('Error fetching EU airlines:', error);
			errorType = 1; // API call failed
			showResultsScreen(null);
			return [];
		}
	};

	const isEUFlight = async flightData => {
		try {
			// Fetch only if the lists are empty
			if (euAirlines.length === 0 || euAirports.length === 0) {
				await fetchEUAirlines();
			}

			const thisFlight = flightData.flights[0];
			const originAirport = thisFlight.origin.code_iata;
			const destinationAirport = thisFlight.destination.code_iata;

			const airportCodes = euAirports.map(airport => airport.iata_code);

			return airportCodes.includes(originAirport) || airportCodes.includes(destinationAirport);
		} catch (error) {
			console.error('Error determining EU flight:', error);
			errorType = 3; // Not covered by EU regulations
			return false;
		}
	};

	const fetchAirportLatLong = async airport => {
		if (!airport) {
			console.warn('Airport code is missing.');
			return null;
		}

		try {
			// Fetch airport data
			const fetchedAirport = await getAirportData(airport, '', false);

			if (fetchedAirport && fetchedAirport.latitude && fetchedAirport.longitude) {
				return [fetchedAirport.latitude, fetchedAirport.longitude];
			}

			console.warn(`No latitude or longitude found for airport: ${airport}`);
			return null;
		} catch (error) {
			console.error(`Error fetching airport data for ${airport}, falling back to Engagement Tools:`, error);

			try {
				const res = await sGetFromEngagementTools(apiKey, `${airportApiUrl}?airport=${airport}`);
				if (!res.ok) {
					throw new Error('Fallback network response was not ok');
				}
				const data = await res.json();

				return [data.latitude, data.longitude];
			} catch (fallbackError) {
				console.error('Error fetching airport data with fallback:', fallbackError);
				errorType = 1; // API call failed
				showResultsScreen(null);
					
				return null;
			}
		}
	};

	const calculateDistance = (lat1, lng1, lat2, lng2) => {
		if (lat1 && lng1 && lat2 && lng2) {
			//const R = 3958.8; // Radius of the Earth in miles
			const R = 6371; // Radius of the Earth in km
			const dLat = (lat2 - lat1) * (Math.PI / 180);
			const dLng = (lng2 - lng1) * (Math.PI / 180);
			const a =
				Math.sin(dLat / 2) * Math.sin(dLat / 2) +
				Math.cos(lat1 * (Math.PI / 180)) *
					Math.cos(lat2 * (Math.PI / 180)) *
					Math.sin(dLng / 2) *
					Math.sin(dLng / 2);
			const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
			return R * c; // Distance decided by radius above
		}
	};

	const compensationCalculation = (delayDuration, distance) => {
		if (delayDuration < 180) {
			return 0;
		} else if (distance <= 1500) {
			return 220;
		} else if (distance <= 3500) {
			return 350;
		} else {
			return distance > 3500 && delayDuration >= 240 ? 520 : 260;
		}
	};

	const scrollToBanner = () => {
		const banner = widget.querySelector('.banner');
		if (banner) {
			banner.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
				inline: 'nearest',
			});
		} else {
			console.warn('Banner element not found in the widget.');
		}
	};

	const swapAirlineText = (airlineName, airlinePolicyPage) => {
		if (!airlineName || !airlinePolicyPage) {
			console.warn('Airline name or claim link is missing.');
			return;
		}
		nextStepsList.forEach(list => {
			list.querySelectorAll('li').forEach(item => {
				if (item.textContent.includes('{airline}')) {
					const parts = item.textContent.split('{airline}');

					// Clear the existing content of the list item
					item.innerHTML = '';

					parts.forEach((part, index) => {
						// Append the text part safely as a text node
						item.appendChild(document.createTextNode(part));

						// If it's not the last part, append the link using the safe function
						if (index < parts.length - 1) {
							sAppendSafeLink(item, {
								// Append directly to the list item
								href: airlinePolicyPage,
								text: airlineName,
								target: '_blank',
								urlOpts: {},
							});
						}
					});
				}
			});
		});
	};

	const showResultsScreen = async flight => {
		resultSections.forEach(section => {
			section.classList.add('display-none');
		});

		scrollToBanner();
		
		switch (errorType) {

			case 0:
				if (flight) {
					const flightDetails = flight.flights[0];
					let distance = flightDetails.route_distance || null;
					const destinationAirportCode = flightDetails.destination.code_iata;
					const scheduledLanding = flightDetails.scheduled_in || null;
					const actualLanding = flightDetails.actual_in || null;

					if (!scheduledLanding || !actualLanding) {
						console.error('Scheduled or actual landing is missing');
						return;
					}

					if (!distance || distance === 0) {
						console.warn('Distance not available, calculating based on origin and destination airports');
						const destinationLatLong = await fetchAirportLatLong(destinationAirportCode);

						if (destinationLatLong) {
							// Use array destructuring to get lat and long
							const [destLat, destLong] = destinationLatLong;

							distance = calculateDistance(
								departureAirportData.latitude,
								departureAirportData.longitude,
								destLat,
								destLong
							);
							distance = distance ? Math.round(distance) : 0; // Round the distance to the nearest km
						}
					}

					let delayDuration = 0;

					if (flightDetails.arrival_delay != null || flightDetails.arrival_delay != undefined) {
						delayDuration = flightDetails.arrival_delay / 60; // Convert seconds to minutes
					} else {
						delayDuration = Math.round((new Date(actualLanding) - new Date(scheduledLanding)) / 60000); // Convert
					}

					// convert to hours and minutes
					const hours = Math.floor(delayDuration / 60);
					const minutes = delayDuration % 60;
					let formattedDelay = '';
					if (hours > 0) {
						formattedDelay += `${hours} hour${hours > 1 ? 's' : ''}`;
					}
					if (minutes > 0) {
						if (hours > 0) {
							formattedDelay += ' and ';
						}
						formattedDelay += `${minutes} minute${minutes > 1 ? 's' : ''}`;
					}
					if (formattedDelay === '') {
						formattedDelay = 'On time';
					}

					compensationDistance.textContent = `${distance} km`;
					compensationDelay.textContent = formattedDelay;

					if (delayDuration < 180) {
						compensationDelaySub3hrs.classList.remove('display-none');
						compensationRegulationLink.classList.remove('display-none');
						compensationValue.classList.add('display-none');
					} else {
						compensationDelaySub3hrs.classList.add('display-none');
						compensationRegulationLink.classList.add('display-none');
						compensationValue.textContent = `£${compensationCalculation(delayDuration, distance)}`;
						compensationValue.classList.remove('display-none');
					}

					widget.querySelector('.departure--value').textContent =
						`${flightDetails.origin.name} (${flightDetails.origin.code_iata})`;
					widget.querySelector('.arrival--value').textContent =
						`${flightDetails.destination.name} (${flightDetails.destination.code_iata})`;
					widget.querySelector('.distance--value').textContent = `${distance} km`;
					widget.querySelector('.delay--value').textContent = `${formattedDelay}`;

					// find flightDetails.operator_iata in euAirlines.airline.airline_iata_code array and retrieve the airline name and policy_page
					const airline = euAirlines.find(a => a.airline_iata_code.includes(flightDetails.operator_iata));

					if (airline) {
						const airlineName = airline.airline;
						const airlinePolicyPage = airline.policy_page;
						
						swapAirlineText(airlineName, airlinePolicyPage);

						
					} else {
						console.error('Airline not found in EU airlines list');
					}

					resultsSuccessScreen.classList.remove('display-none');
				} else {
					apiCallFailedScreen.classList.remove('display-none');
				}

				break;

			case 1:
				apiCallFailedScreen.classList.remove('display-none');
				break;
			case 2:
				flightNotFoundScreen.classList.remove('display-none');
				break;
			case 3:
				notCoveredRegsScreen.classList.remove('display-none');
				break;
		}
	};

	return {
		init: init,
	};
})();

document.addEventListener('DOMContentLoaded', function () {
	airlineDelay.init();
});
